module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-19.2aa297ea.JPG";